import React from "react";
import { Box, Typography, Tag } from "@orion/ui";
import { Checkmark, Close } from "@orion/icons";
import { useTranslation } from "react-i18next";

type Props = {
  passwordCriteria: {
    key: string;
    label: string;
    description: string;
  }[];
  checkValidation: Record<string, boolean>;
  dirtyFields: { newPassword: boolean };
};

const PasswordValidationTags: React.FC<Props> = ({
  passwordCriteria,
  checkValidation,
  dirtyFields,
}) => {
  const { t } = useTranslation();
  
  const getTagVariant = (isValid: boolean) => {
    if (!dirtyFields.newPassword) return "primaryLight";
    return isValid ? "success" : "error";
  };

  return (
    <Box flex gap10 mb10 style={{ flexWrap: "wrap" }}>
      {passwordCriteria.map(({ key, label, description }) => {
        const isValid = checkValidation[key];

        return (
          <Tag
            key={key}
            display="inline-flex"
            alignItems="center"
            style={{ whiteSpace: "nowrap" }}
            variant={getTagVariant(isValid)}
            aria-describedby={`desc-${key}`}
            rounded
          >
            <Box flex>
              {isValid ? (
                <Checkmark ml3 width="11" height="10" />
              ) : (
                <Close ml3 width="10" height="10" />
              )}
              <Typography
                textSm
                fontBold
                aria-hidden={dirtyFields.newPassword ? "true" : "false"}
              >
                {label}
              </Typography>
            </Box>
            {dirtyFields.newPassword && (
              <div
                aria-live="assertive"
                style={{
                  position: "absolute",
                  width: "1px",
                  height: "1px",
                  padding: 0,
                  margin: "-1px",
                  overflow: "hidden",
                  clip: "rect(0, 0, 0, 0)",
                  whiteSpace: "nowrap",
                  border: 0,
                }}
              >
                {isValid
                  ? label + t("accessibility.resetPassword.satisfied")
                  : label + t("accessibility.resetPassword.notSatisfied")}
              </div>
            )}
          </Tag>
        );
      })}
    </Box>
  );
};

export default PasswordValidationTags;
